import axios from 'lib/axios'

const base = (packageHashedId) =>
  `/package_hook/${packageHashedId}/ny_1120b/extensions/custom_requests`

export const approve = (packageHashedId, requestId) =>
  axios.post(`${base(packageHashedId)}/approve`, { request_id: requestId })

export const deny = (packageHashedId, requestId, reason) =>
  axios.post(`${base(packageHashedId)}/deny`, { request_id: requestId, reason })
